// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".products-grid--loading{-moz-column-gap:var(--base);column-gap:var(--base);grid-auto-rows:0;grid-template-rows:repeat(3,1fr);overflow-y:hidden;row-gap:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
